// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  logger_dsn: window.env?.loggerDSN,
  logger_log_level: window.env?.loggerLogLevel,
  logger_monitoring_type: window.env?.loggerMonitoringType,
  production: false,
  base_url: 'https://auth.globus-baumarkt.de',
  cdn_url: 'https://cdn.cidaas.de',
  build_path: 'user-ui/default-hosted-pages-webapp/dev-v1/b32ab105b20af006e24c331599ac99221efc7e19-247104/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
